export default "__VITE_ASSET__SNdzQyL4__"